import React from 'react'
import style from './Engineering.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const Engineering = () => {
  const { t } = useTranslation()
  return (
    <div className={style.engineering} id="engineering">
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <h2 className={style.title}>{t('engineering.title')}</h2>
        <p className={style.desc}>{t('engineering.desc')}</p>
        <Link to={'/engineering'} className={style.button}>
          {t('engineering.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default Engineering
